import { ButtonBase, styled } from '@mui/material';

import Note from '../../components/Note';

export const Root = styled(ButtonBase)(({ theme }) => ({
  width: '100%',
  borderRadius: 8,
  textAlign: 'left',
  ...theme.typography.paragraphRegular,
}));

export const Tip = styled(Note)(({ theme }) => ({
  width: '100%',
  '& p': {
    margin: 0,
  },
}));
